<template>
  <div class="language-switcher">
    <h3 class="switcher-heading">{{ $t('Base.language') }}</h3>
    <div class="lang-container">
      <div v-for="(lang, i) in languages" :key="i" class="lang" @click="selectLocale(lang)">
        <span :class="{'active-language': lang.toLowerCase() === $i18n.locale}">{{ (appConfigDateFormats[lang.toLowerCase()] && appConfigDateFormats[lang.toLowerCase()].switcherDisplayName) || lang}}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { localeProperties, loadLanguageAsync } from '@/library/locale/i18n'
import store from '@/store'
import config from '@/config'
export default {
  name: 'languageSwitcher',
  data () {
    return {
      languages: localeProperties.getSupportedLocales,
      locale: this.$i18n.locale,
      onMounted: false
    }
  },
  computed: {
    appConfigDateFormats () {
      return config.app.appConfigDateFormats
    }
  },
  methods: {
    setLocaleOnPageLoad () {
      if (this.$i18n.locale !== this.locale) {
        this.onMounted = true
        this.locale = this.$i18n.locale
      }
    },
    selectLocale (lang) {
      if (lang.toLowerCase() !== this.locale) {
        this.locale = lang.toLowerCase()
      }
    }
  },
  mounted () {
    setTimeout(() => {
      this.setLocaleOnPageLoad()
    }, 1000)
  },
  watch: {
    locale (newVal) {
      console.log('locale watch', newVal)
      if (newVal) {
        if (this.onMounted) {
          this.onMounted = false
          return false
        }
        localStorage.userLocale = newVal
        store.commit('setLanguageChangeDetected', true)
        loadLanguageAsync(newVal)
        let to = this.$router.resolve({ params: {lang: newVal} })
        this.$router.push(to.location)
        return false
      }
    }
  }
}
</script>

<style lang="stylus">
.language-switcher
  display: flex
  flex-direction column
  h3.switcher-heading
    padding-left 0px
  .lang-container
    padding-left 0px
    display flex
    align-items: center
    flex-wrap: wrap
    .lang
      padding-right 20px
      display flex
      cursor pointer
      span.active-language
        padding 3px 10px
        border-radius 5px
        background #ff671f
        font-weight bold
        color #fff
</style>



// WEBPACK FOOTER //
// src/components/layout/parts/LanguageSwitcher.vue